import Script from 'next/script';

const HeadAiScript = () => (
  <Script async src="https://scripts.ahalab.io/track-v2.js"
        data-aha-client-id="org_2xwayCdhQ3QQAuiR29PxDp0TOhU"></Script>
);

export default HeadAiScript;